import { z } from "zod";
import { Image } from "../../shared/widgets/ImageManager";

//Zod schema

export const MarketingManagerSchema = z
  .object({
    desktopImages: z.array(z.any()),
    mobileImages: z.array(z.any()),
    startDate: z.string().nullable().optional(),
    endDate: z.string().nullable().optional(),
    redirectUrl: z
      .string()
      .optional()
      .refine(val => !val || z.string().url().safeParse(val).success, {
        message: "marketingManager.validation.invalidUrl",
      }),
  })
  .refine(
    data => {
      if (data.startDate && data.endDate) {
        return new Date(data.endDate) > new Date(data.startDate);
      }
      return true;
    },
    {
      message: "marketingManager.validation.endDateAfterStartDate",
      path: ["endDate"],
    }
  )
  .refine(data => !(data.desktopImages.length > 0 && data.mobileImages.length === 0), {
    message: "marketingManager.validation.mobileRequired",
    path: ["mobileImages"],
  })
  .refine(data => !(data.mobileImages.length > 0 && data.desktopImages.length === 0), {
    message: "marketingManager.validation.desktopRequired",
    path: ["desktopImages"],
  });

export type MarketingManagerFormValues = z.infer<typeof MarketingManagerSchema>;

//Domain entity

interface MarketingManagerProps {
  id: string;
  desktopImages: Image[];
  mobileImages: Image[];
  startDate?: string;
  endDate?: string;
  redirectUrl?: string;
}

export class MarketingManagerEntity {
  private constructor(
    readonly id: string,
    readonly desktopImages: Image[],
    readonly mobileImages: Image[],
    readonly startDate: string | undefined,
    readonly endDate: string | undefined,
    readonly redirectUrl: string | undefined
  ) {}

  static create(props: MarketingManagerProps): MarketingManagerEntity {
    return new MarketingManagerEntity(
      props.id,
      props.desktopImages,
      props.mobileImages,
      props.startDate,
      props.endDate,
      props.redirectUrl
    );
  }

  hasImages(): boolean {
    return this.desktopImages.length > 0 || this.mobileImages.length > 0;
  }

  isValidityPeriodSet(): boolean {
    return Boolean(this.startDate && this.endDate);
  }
}
